import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

function yearlyAmount({ data, currency }) {
  const parseAmount = (amountStr) => parseFloat(amountStr.replace(/,/g, ''));

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  const monthlyInvoiceData = data.map((yearData) => ({
    name: yearData.year.toString(),
    data: yearData.months.map((monthData) => ({
      x: months.indexOf(monthData.month),
      y: parseAmount(monthData.total_amount),
      month: monthData.month,
      amount: parseAmount(monthData.total_amount),
      count: monthData.total_invoices
    }))
  }));

  const generateColors = (count) => {
    const colors = [];
    for (let i = 0; i < count; i += 1) {
      const hue = (i * 360) / count;
      colors.push(`hsl(${hue}, 70%, 50%)`);
    }
    return colors;
  };

  const splineChartOptions = {
    chart: {
      type: 'spline',
      backgroundColor: '#fafafa'
    },
    title: {
      text: 'Monthly Invoice Amount Trends',
      style: {
        fontSize: '24px',
        fontWeight: 'bold'
      }
    },
    xAxis: {
      categories: months,
      title: { text: 'Month' },
      gridLineWidth: 1,
      gridLineColor: '#e6e6e6'
    },
    yAxis: {
      title: { text: `Invoice Amount (${currency})` },
      gridLineWidth: 1,
      gridLineColor: '#e6e6e6',
      min: 0
    },
    tooltip: {
      shared: true,
      crosshairs: true,
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      shadow: true,
      useHTML: true,
      formatter() {
        let tooltipContent = `<div style="font-weight: bold; margin-bottom: 8px;">${this.x}</div>`;
        this.points.forEach((point) => {
          const monthData = data
            .find((year) => year.year.toString() === point.series.name)
            ?.months.find((m) => m.month === this.x);
          const amount = monthData ? parseAmount(monthData.total_amount) : 0;
          tooltipContent += `
            <div style="margin-bottom: 4px;">
              <span style="color: ${point.color};">●</span>
              <strong>${point.series.name}:</strong> ${point.point.count} invoices<br/>
              <span style="margin-left: 12px; color: #666;">
                Amount: ${currency} ${amount.toLocaleString()}
              </span>
            </div>`;
        });
        return tooltipContent;
      }
    },
    plotOptions: {
      spline: {
        marker: { radius: 5, lineColor: '#666', lineWidth: 2, fillColor: 'white' },
        lineWidth: 3,
        states: { hover: { lineWidth: 4 } }
      }
    },
    legend: {
      align: 'center',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      backgroundColor: 'white',
      borderColor: '#ccc',
      borderWidth: 1,
      borderRadius: 5,
      padding: 10
    },
    series: monthlyInvoiceData,
    colors: generateColors(data.length),
    credits: { enabled: false }
  };

  return (
    <Box>
      <HighchartsReact highcharts={Highcharts} options={splineChartOptions} />
    </Box>
  );
}

yearlyAmount.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      // Add other properties expected in the object
    })
  ).isRequired,
  currency: PropTypes.string.isRequired
};

export default yearlyAmount;
